import { useState, useCallback, useEffect } from 'react'
import { useForm, useWatch } from 'react-hook-form'
import styles from './FindCredentials.module.scss'
import SelfVerification from '../signup/components/SelfVerification/SelfVerification'
import BackButton from '../../components/buttons/BackButton/BackButton'
import UserFound from './UserFound'
import UserNotFound from './UserNotFound'
import axios from 'axios'

export const FindCredentials = () => {
	const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT
	const [page, setPage] = useState(0)
	const [userName, setUserName] = useState('')
	const [foundUser, setFoundUser] = useState(null)
	const { setValue, control, getValues, reset } = useForm()
	const returnURL = `${window.location.origin}/certify/complete`
	const [verifiedStatus, setVerifiedStatus] = useState('notTried')
	const [encData, setEncData] = useState('')
	const [tokenVersionId, setTokenVersionId] = useState('')

	const handleVerificationSuccess = useCallback(
		(info) => {
			setValue('name', info.name)
			setValue('phoneNumber', info.phoneNumber)
		},
		[setValue],
	)

	const handleCertData = useCallback(({ encData, tokenVersionId }) => {
		setEncData(encData)
		setTokenVersionId(tokenVersionId)
	}, [])

	const watchedAll = useWatch({
		control: control,
		name: ['name', 'phoneNumber'],
	})

	const handleNext = useCallback(() => {
		// get form values
		const { name, phoneNumber } = getValues()
		console.log('name:', name)
		Promise.all([
			axios.get(`${API_ENDPOINT}/users/user/pro/search/${name}`),
			axios.get(`${API_ENDPOINT}/users/user/caddie/search/${name}`),
		])
			.then(([proRes, caddieRes]) => {
				const proUsers = Array.isArray(proRes.data) ? proRes.data : []
				const caddieUsers = Array.isArray(caddieRes.data) ? caddieRes.data : []
				const users = [...proUsers, ...caddieUsers]
				console.log('combined users:', users)
				const matchedUser = users.find((user) => user.phone === phoneNumber)
				console.log('matchedUser:', matchedUser)
				if (matchedUser) {
					setFoundUser(matchedUser)
					console.log('foundUser:', foundUser)
					setPage(1)
					setVerifiedStatus('notTried')
					reset()
				} else {
					console.log('이름이랑 매칭되는 유저가 없다')
					setPage(2)
					setVerifiedStatus('notTried')
					reset()
				}
			})
			.catch((err) => {
				console.error('catched err:', err)
				setPage(2)
			})
	}, [setPage])

	if (page === 0) {
		return (
			<div className={styles.findWrapper}>
				<div style={{ width: '360px' }}>
					<BackButton />
				</div>
				<form className={styles.mainForm}>
					<div className={styles.title}>계정/비밀번호 찾기</div>
					<SelfVerification
						verifiedStatus={verifiedStatus}
						changeVerifiedStatus={setVerifiedStatus}
						onVerificationSuccess={handleVerificationSuccess}
						onCertData={handleCertData}
					/>
				</form>
				<div style={{ width: '360px' }}>
					<button
						className={styles.nextButton}
						type="button"
						style={{
							backgroundColor: watchedAll.every(Boolean) ? '#1b1b1b' : 'white',
						}}
						disabled={!watchedAll.every(Boolean)}
						onClick={handleNext}>
						다음
					</button>
				</div>
				{/*nice 서버에 submit할 form*/}
				<form
					name="form"
					id="form"
					action="https://nice.checkplus.co.kr/CheckPlusSafeModel/service.cb">
					<input type="hidden" id="m" name="m" value="service" />
					<input type="hidden" id="token_version_id" name="token_version_id" value="" />
					<input type="hidden" id="enc_data" name="enc_data" />
					<input type="hidden" id="integrity_value" name="integrity_value" />
					<input type="hidden" name="ReturnURL" value="" />
				</form>
			</div>
		)
	}
	if (page === 1) {
		return (
			<div className={styles.findWrapper}>
				<UserFound user={foundUser} page={page} setPage={setPage} />
			</div>
		)
	} else if (page === 2) {
		console.log('if page === 2까지 왔다')
		return (
			<div className={styles.findWrapper}>
				<UserNotFound page={page} setPage={setPage} />
			</div>
		)
	}
}
